export default __webpack_public_path__ + "static/017-9fb5251e08fe0b735dc4150878687e47.jpg";